import { forwardRef, type ComponentProps } from "react";
import { Salaries } from "@userFrontend/features/publication/components/Salaries";
import * as styles from "./styles.css";

type Props = {
  gaAction?: string;
  gaLabel?: string;
  onClickLink?: () => void;
  url: string;
  imgSrc: string;
  shopName: string;
  title: string;
  shopAddress: {
    city: string;
    prefecture: string;
    station: string;
  };
  hasBorder?: boolean;
  isShowLocationOnlyOneLine?: boolean;
} & ComponentProps<typeof Salaries>;

export const NoButtonWorkCassette = forwardRef<HTMLAnchorElement, Props>(
  (
    {
      gaAction,
      gaLabel,
      onClickLink,
      url,
      imgSrc,
      shopName,
      title,
      employmentAndSalaryType,
      shopAddress: { city, prefecture, station },
      hasBorder = false,
      isShowLocationOnlyOneLine = false,
    },
    ref,
  ) => {
    return (
      <a
        href={url}
        className={styles.cassette({ hasBorder })}
        data-ga-action={gaAction}
        data-ga-label={gaLabel}
        onClick={onClickLink}
        ref={ref}
      >
        <div className={styles.shopNameAndImage}>
          <img
            src={imgSrc}
            className={styles.image}
            alt={`${shopName}の画像`}
            width={657}
            height={370}
            loading="lazy"
          />
          <p className={styles.shopName}>{shopName}</p>
        </div>
        <p className={styles.title}>{title}</p>
        <div className={styles.salariesOuter}>
          <Salaries employmentAndSalaryType={employmentAndSalaryType} />
        </div>
        <p className={styles.location({ isShowLocationOnlyOneLine })}>
          {prefecture} {city}
          {station && `（${station}）`}
        </p>
      </a>
    );
  },
);
NoButtonWorkCassette.displayName = "NoButtonWorkCassette";
